var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"list_row"},[_c('div',{staticClass:"list_row_text",domProps:{"textContent":_vm._s(item)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }